import React from 'react';
import { useSelector } from 'react-redux';
import { PasslyButton } from '@app/components';

export function PageActions(props: any) {
    const loaderBtnState: boolean = useSelector((state: any) => state.modal.modalLoaderBtn);

    return (
        <div className={`page-actions__container page-actions__container-${props.justify}`}>
            {props.onClickSecondary && (
                <PasslyButton className='page-actions__button-first' variant='outlined' onClick={props.onClickSecondary}>
                    {props.secondaryBtn}
                </PasslyButton>
            )}
            {props.onClickPrimary && (
                <PasslyButton
                    onClick={props.onClickPrimary}
                    className='page-actions__button-second'
                    color='primary'
                    variant='contained'
                    type='button'
                    disabled={props.disabled || loaderBtnState || props.isLoading}
                    isLoading={loaderBtnState || props.isLoading}
                >
                    {props.primaryBtn}
                </PasslyButton>
            )}
        </div>
    );
}
